import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  chats = 'chats',
  chat = 'chat',
}

enum ExternalRoutesIds {
  projectChat = 'projectChat',
}

export const chatsRouteRef = createRouteRef({ id: RoutesIds.chats });

export const rootRouteRef = chatsRouteRef;

export const chatRouteRef = createSubRouteRef({
  id: RoutesIds.chat,
  parent: rootRouteRef,
  path: '/:id',
});

export const projectChatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.projectChat,
  params: ['id', 'chatId'],
  optional: true,
});

export const Routes = {
  chats: chatsRouteRef,
  chat: chatRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  projectChat: projectChatRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
